export enum State {
  IN_PROGRESS = 'EN_COURS',
  CLOSED = 'CLOTURE',
  EXPIRED = 'EXPIRE',
}
